import { createAction, props } from '@ngrx/store';
import { SyncVendor } from '@capital-access/common/utils';

export const syncCalendars = createAction('[Common Calendar Sync] Sync', props<{ vendor?: SyncVendor }>());
